import { apiPaths, RelativeRootEnum } from 'configs/apiConfigs'
import { IUser } from 'features/auth/types'
import { IUserRoleGuidEnum, UserPreferencesKeysEnum } from 'features/settings/settingsTypes'
import { getSearchText } from 'pages/Claims/helper'
import { IApplyFilter, OperatorTypeEnum } from 'types/tableTypes'
import { encodeUri } from 'utils/api'
import storage, { StorageEnum } from 'utils/storage'
import { CSCreateQuery, CSRestQuery, Filter, Sort } from '../claimTypes'
import { OUTBOUND_USER, SEARCH_LIMIT, USER_LIMIT } from '../components/ClaimDetails/Internal/Constants'

export const generateQueryStringFromFilters = (filters: IApplyFilter[]): string => {
  const query = [] as string[]
  const supportedOperations = JSON.parse(localStorage.getItem('supportedOperations')!)
  filters.forEach((filter) => {
    const { prop, values } = filter
    const levelofSupportFilter: string[] = []

    if (prop === 'levelOfSupport') {
      values.forEach((value) => {
        supportedOperations?.[value! === null ? 'NotSupported' : value].forEach((operation: any) => {
          levelofSupportFilter.push(operation.levelOfSupport === 'NotSupported' ? null : operation.levelOfSupport)
        })
      })
    }

    if (filter.type === OperatorTypeEnum.range) {
      if (values[0]) {
        query.push(
          `Filter=${encodeUri({
            path: prop,
            operator: '>=',
            value: values[0],
          })}`,
        )
      }

      if (values[1]) {
        query.push(
          `Filter=${encodeUri({
            path: prop,
            operator: '<=',
            value: values[1],
          })}`,
        )
      }
    } else if (filter.type === OperatorTypeEnum.oneOf) {
      query.push(
        `Filter=${encodeUri({
          path: prop,
          operator: 'in',
          valueList: prop === 'levelOfSupport' ? [...new Set(levelofSupportFilter)] : filter.values,
        })}`,
      )
    } else {
      query.push(
        `Filter=${encodeUri({
          path: prop,
          operator: 'like',
          value: `%${values[0]}%`,
        })}`,
      )
    }
  })
  return query.join('&')
}

// Temp until we will have a user profile
export enum ILocalStorageSuffixEnum {
  filters = 'filters',
  sorting = 'sorting',
}

export const getUserListQuery = (offset: number, text?: string) => {
  const currentUser: IUser = storage.get(StorageEnum.currentUser)
  const isCurrentUserOutboundUser = currentUser.email.toLocaleLowerCase().endsWith(OUTBOUND_USER)

  const oaiUserQuery = new CSRestQuery(USER_LIMIT, offset)

  /**
   * Set Permissions for the user search results
   */
  const preferredTenant = sessionStorage.getItem(UserPreferencesKeysEnum.outboundAiPreferredTenant)
  oaiUserQuery.addFilter(new Filter('_permissionId', null, IUserRoleGuidEnum.claimAccessPermission!))

  if (!isCurrentUserOutboundUser) {
    oaiUserQuery.addFilter(new Filter('email', 'notlike', `%${OUTBOUND_USER}%`))
  }

  /**
   * To skip adding previous user in the list setting this (isSearch) flag.
   */
  const isSearch = offset <= 0 ? true : false
  if (text && text?.length >= SEARCH_LIMIT) {
    const searchText = getSearchText(text)
    oaiUserQuery.addFilter(new Filter('fullTextVector', '@@', [searchText]))
  }

  oaiUserQuery.addSort(new Sort('givenName'))
  oaiUserQuery.addSort(new Sort('familyName'))

  const manageQuery = new CSCreateQuery(oaiUserQuery)
  const prepareUrl = `tenants/${preferredTenant}/${RelativeRootEnum.users}`
  const url = apiPaths.userSearch(prepareUrl, manageQuery).replace(',', '')
  const updatedUrl = url.replace(',', '')

  return {
    isSearch,
    updatedUrl,
  }
}
